import { render } from "./FileItemSimplified.vue?vue&type=template&id=17712b26&ts=true"
import script from "./FileItemSimplified.vue?vue&type=script&lang=ts"
export * from "./FileItemSimplified.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__